import axios from '../axios'
import URL from '@/_url_'
import qs from 'qs'

let lang = localStorage.lang,
// 订单搜索条件
order_tabs = sessionStorage.getItem("order_tabs") || "9",
order_sn = sessionStorage.getItem("order_sn") || "",
release = sessionStorage.getItem("release") || "",
relend = sessionStorage.getItem("relend") || "",
department = sessionStorage.getItem("department") || "",
user_id = sessionStorage.getItem("member") || "";

function handleImg(data){
    for(let item of data){
        let newImgs = [];
        if(item.goods_images){
            newImgs=item.goods_images.split(",") || "";
            for(let i in newImgs){
                if(newImgs[i].indexOf('http')<0){
                    newImgs[i]=URL.imgUrl+newImgs[i];
                }
            }
            item.goods_images = newImgs;
        }
    }
}

export default {
	
    state: {
        // 
        // ************* 购物车 ********************
        // 
        cart: [], // 购物车
        limit_amount: 0, // 单笔限制金额
        limit_month: 0, // 月限制金额
        cart_order: [], // 购物车订单
		id_order: [], // 购物车订单id
        // 
        // ************* 购物车订单 ********************
        // 
        cart_address: [], // 购物车收件地址列表
        select_address: {}, // 选中收件地址
        cart_department: [], // 部门信息
        // 
        // ************* 订单状态 ********************
        // 
        order_tabs: order_tabs, // 订单状态标签页
        order_status: [], // 订单状态列表

        order_detail: {}, // 订单详情
        order_log: [], //订单日志
        order_goods: [], // 订单商品
		order_goodsr:[],
        examine: -1, // 当前订单审核状态
		order_goodsr_quote_sn:"",// 订单id
        // 
        // ************* 订单管理 ********************
        // 
        order_list: [], // 订单列表
        order_month: [], // 月订单列表
		order_month_page:{
			current_page:0,//当前页数
			last_page:0,//一共多少页
			per_page:10,//每页多少数据
			total:10//一共多少条数据
		},// 月订单页数
		month:'',//月份
		
        // 
        // ************* 报价车 ********************
        // 
        quote_cart: [], // 报价车
        // 
        // ************* 报价车订单 ********************
        // 
        quote_examine: 0, // 报价车审核权限
        quote_order_list: [], // 报价车订单列表
        quote_order_detail: [], // 报价车订单详情
        quote_order_detail_goods: [], // 报价车订单商品
		quote_order_detail_goodsr:[],// 报价车订单商品刪減版
		quote_order_quote_sn:"",// 报价车订单id
    },
    mutations: {
        // 
        // ************* 购物车 ********************
        // 
        setCart(state, arg){
            handleImg(arg.cart);
            state.cart = arg.cart;
            state.limit_amount = arg.limit_amount;
            state.limit_month = arg.month;
        },
        setCartOrder(state, arg ){
            state.cart_order = arg[0];
			state.id_order = arg[1]
			console.log("查看",arg)
        },
        // 
        // ************* 购物车订单 ********************
        // 
        setCartAddress(state, arg){
            state.cart_address = arg;
        },
        setSelectAddress(state, arg){
            if(arg){
                state.select_address = arg;
            }else{
                state.select_address = {};
            }
        },
        setCartDepartment(state, arg){
            state.cart_department = arg;
        },
        // 
        // ************* 订单状态 ********************
        // 
        setOrderTabs(state, arg){ // 订单标签页切换
            state.order_tabs = arg;
        },
        setOrderStatusList(state, arg){ // 写入订单状态列表参数
            for(var val of arg){
                val.createtime=val.createtime.split(' ')[0];
            }
            state.order_status = arg;
        },
        clearOrderStatusList(state){ // 清空订单状态列表参数
            state.order_status = [];
        },
        setOrderStatusDetail(state, arg){ // 写入订单状态详情参数
            handleImg(arg.goods); // 判断是否需要添加前缀
            state.order_goods = arg.goods;
            state.examine = arg.respon === undefined? -1: arg.respon; // 订单审核状态写入
            state.order_log = arg.log; //订单日志
            arg.order.createtime = arg.order.createtime.split(' ')[0]; // 处理时间参数
            if(arg.order.PDF_bottom_sheet) // 处理PDF
                arg.order.PDF_bottom_sheet = arg.order.PDF_bottom_sheet.split(",");
            if(arg.order.sign_picture) // 处理签收图片
                arg.order.sign_picture = arg.order.sign_picture.split(",");
            state.order_detail = arg.order; // 订单详情
        },
		removeUnnecessaryParameters2(state,arg){ // 写入报价车订单详情
			//去掉沒有必要的參數
			let detail2 = JSON. parse(JSON. stringify(arg.goods));
			state.order_goodsr_quote_sn = arg.order.order_sn
			state.order_goodsr  = detail2;
			state.order_goodsr.forEach(el => {
				delete el.attr_value
				delete el.goods_attr
				delete el.goods_name
				delete el.goods_price
				delete el.num
				delete el.remark
				delete el.unit
				delete el.unit_price
			});
		},
        clearOrderStatusDetail(state){ // 清空订单状态详情参数
            state.examine = -1;
            state.order_detail = {};
            state.order_log = [];
            state.order_goods = [];
        },
        // 
        // ************* 订单管理 ********************
        // 
        setOrderList(state, arg){ // 写入订单列表
            state.order_list = arg;
        },
        setOrderMonth(state, arg){ // 写入当月订单
            state.order_month = arg;
			
			
        },
		setMonth(state, arg){ // 写入当月订单
		    state.month = arg;
			// console.log("查看",arg)
		},
		// 月订单页数
		setOrderMonthPage(state, arg){
			state.order_month_page = arg;
			// console.log("查看",state.order_month_page)
		},
        // 
        // ************* 报价车 ********************
        // 
        setQuoteCart(state, arg){ // 写入报价车
            // 判断是否需要添加前缀
            for(let item of arg){
                let newImgs = [];
                newImgs=item.goods_images.split(",");
                for(let i in newImgs){
                    if(newImgs[i].indexOf('http')<0){
                        newImgs[i]=URL.imgUrl+newImgs[i];
                    }
                }
                item.goods_images = newImgs;
            }
            state.quote_cart = arg;
        },
        // 
        // ************* 报价车订单 ********************
        // 
        setQuoteOrderList(state, arg){ // 写入报价车订单列表
            state.quote_order_list = arg;
        },
        setQuoteOrderDetail(state, arg){ // 写入报价车订单详情
            if(JSON.stringify(arg)  == "{}"){	
                state.quote_examine = 0;
                state.quote_order_detail = {};
                state.quote_order_detail_goods = [];
                return
            }
            handleImg(arg.goods);
            state.quote_examine = Number(arg.respon);
            state.quote_order_detail = arg.quote;
            state.quote_order_detail_goods = arg.goods;
	
			
		
        },
		removeUnnecessaryParameters(state,arg){ // 写入报价车订单详情
			//去掉沒有必要的參數
			state.quote_order_quote_sn = arg.quote.quote_sn;
			let detail2 = JSON. parse(JSON. stringify(arg.goods));
			state.quote_order_detail_goodsr = detail2;
			state.quote_order_detail_goodsr.forEach(el => {
				delete el.attr_value
				delete el.goods_attr
				delete el.goods_name
				delete el.goods_price
				delete el.num
				delete el.remark
				delete el.unit
				delete el.unit_price
				
			});
			// console.log("查看",state.quote_order_quote_sn)
		},
    },
    actions: {
        // 
        // ************* 购物车 ********************
        // 
        getCart({commit, rootState}){ // 获取购物车
            if(rootState.user.islogin){ // 判断是否登录
				let url = "/index/cart/cart_list?lang=" + lang;
				axios.get(url).then((res) => {
					if(res.data.code == 1){
						commit("setCart", res.data)
					}
				}).catch(() => {})
				let timer = setInterval(()=>{
					console.log("五分钟执行一次")
					let url = "/index/cart/cart_list?lang=" + lang;
					axios.get(url).then((res) => {
					    // if(res.data.code == 1){
					    //     commit("setCart", res.data)
					    // }
					}).catch(() => {})
				}, 300000);
				
            }
        },
        handleCartNum({dispatch}, arg){ // 购物车数量更改
            let { goods_number, rec_id, goods_attr_id } = arg;
            let url = "/index/cart/change", 
            data = qs.stringify({
                rec_id,
                goods_number,
                goods_attr_id
            })
            return new Promise((resolve, reject) => {
                axios({
                    method: "POST",
                    url,
                    data
                }).then((res) => {
                    if(res.data.code == 1){
                        dispatch("getCart");
                        resolve({
                            type: true
                        })
                    }else if(res.data.code == 2){
                        resolve({
                            type: false
                        })
                    }
                }).catch(() => {})
            })
        },
        handleCartDel({dispatch}, arg){ // 购物车删除
            return new Promise((resolve) => {
                let url = "/index/cart/delete_cart",
                data = qs.stringify({
                    rec_id: arg
                })
                axios({
                    method: "POST",
                    url,
                    data
                }).then((res) => {
                    if(res.data.code == 1){
                        dispatch("getCart");
                        resolve(true)
                    }
                }).catch(() => {})
            })
        },
        // 
        // ************* 购物车订单 ********************
        // 
        getCartAddress({ rootState, commit }){ // 获取购物车订单地址列表
            let user_id = rootState.user.user_info.id,
            url = "/index/cart/address",
            data = qs.stringify({
                user_id
            })
            axios({
                method: "POST",
                url,
                data
            }).then((res) => {
                if(res.data.code == 1){
                    commit("setCartAddress", res.data.address)
                    commit("setSelectAddress", res.data.address[0])
                }
            }).catch(() => {})
        },
        getCartDepartment({ rootState, commit }){ // 获取购物车订单部门列表
            let company_id = rootState.user.user_info.company_id,
            url = "/index/cart/member?lang="+lang+"&company_id="+company_id;
            axios.get(url).then((res) => {
                if(res.data.code == 1){
                    commit("setCartDepartment", res.data.department)
                }
            }).catch(() => {})
        },
        submitCartOrder({ state, commit, dispatch}, arg){ // 提交购物车订单
			// console.log(state.select_address,"查看")
            commit("handleLoading", true);
            let { department_id, remark } = arg,
            { consignee, address, mobile, email } = state.select_address,
            // goods = state.cart_order,
			goods = state.id_order,
            url = "/index/cart/add",
            data = qs.stringify({
                department_id,
                remark,
                consignee,
                address,
                mobile,
                email,
                goods
            })
            return new Promise((resolve) => {
                axios({
                    method: "POST",
                    url,
                    data
                }).then((res) => {
					commit("handleLoading", false);
					// 刷新列表
                    if(res.data.code == 1){
                        resolve({
                            type: 1,
							order_id:res.data.order_id
                        })
                    }else if(res.data.code == 2){
                        resolve({
                            type: 2
							
                        })
					
                    }else if(res.data.code == 3){
                        resolve({
                            type: 3,
                            msg: res.data.msg
							
                        })
						
                    }else if(res.data.code == 4){
                        resolve({
                            type: 4,
                            msg: res.data.msg
							
                        })
                    }else if(res.data.code == 8){
					    resolve({
					        type: 8
							
					    })
					}
                }).catch(err => {
                    commit("handleLoading", false);
                    alert(`提交购物车订单接口异常：${err}，请联系管理员`);
                })
            })
        },
        // 
        // ************* 订单状态 ********************
        // 
        getOrderStatusList({ state, commit }, arg){ // 获取订单状态列表
            commit('clearOrderStatusList');
            commit('handleLoading', true);
            let { 
                release = '', 
                relend = '', 
                order_sn = '', 
                department = '', 
                user_id = '' ,
                status = '',
                orstatus = '',
                attr: sortAttr = '',
                mode: sortMode = '',
                page = 1
            } = arg;
            let url = '/index/orderstatus/order_status',
            data = qs.stringify({
                lang,
                release,
                relend,
                order_sn,
                department,
                user_id,
                status,
                orstatus,
                sortAttr,
                sortMode,
                page
            })
            axios({
                method: 'POST',
                url,
                data
            }).then((res) => {
                if(res.data.code == 1){
                    commit('setOrderStatusList', res.data.order);
                    commit('setPage', res.data.page);
                }
            }).catch(err => {
                alert(`获取订单状态列表接口异常：${err}，请联系管理员`);
            }).finally(() => {commit('handleLoading', false)})
        },
		getOrderStatusDetail2({ commit }, arg){ // 获取订单详情
		    commit("clearOrderStatusDetail");
		    commit("handleLoading", true);
		    let url = "/index/orderstatus/goods",
		    data = qs.stringify({
		        id: arg
		    })
		    axios({
		        method: "POST",
		        url,
		        data
		    }).then((res) => {
		        commit("handleLoading", false);
		        if(res.data.code == 1){
		            commit("setOrderStatusDetail", res.data);
					commit("removeUnnecessaryParameters2", res.data);		
		            commit("handleDialog", true);
					commit("handleFalse", true);
		        }
		    }).catch(err => {
		        commit("handleLoading", false);
		        alert(`获取订单详情接口异常：${err}，请联系管理员`);
		    })
		},
        getOrderStatusDetail({ commit }, arg){ // 获取订单详情
            commit("clearOrderStatusDetail");
            commit("handleLoading", true);
            let url = "/index/orderstatus/goods",
            data = qs.stringify({
                id: arg
            })
            axios({
                method: "POST",
                url,
                data
            }).then((res) => {
                commit("handleLoading", false);
                if(res.data.code == 1){
                    commit("setOrderStatusDetail", res.data);
					commit("removeUnnecessaryParameters2", res.data);
					commit("handleDialog", true)
                }
            }).catch(err => {
                commit("handleLoading", false);
                alert(`获取订单详情接口异常：${err}，请联系管理员`);
            })
        },
        changeOrderStatusGoods({ commit }, arg){ // 修改订单详情商品
            return new Promise((resolve) => {
                let { rec_id, goods_number, remark = "", id } = arg,
                url = "/index/orderstatus/edit_goods",
                data = qs.stringify({
                    lang,
                    rec_id,
                    goods_number,
                    remark,
                    id
                })
                axios({
                    method: "POST",
                    url,
                    data
                }).then((res) => {
                    if(res.data.code == 1){
                        commit("setOrderStatusDetail", res.data);
						commit("removeUnnecessaryParameters2", res.data);
                        resolve(true)
                    }
                }).catch(() => {})
            })
        },
        delOrderStatusGoods({}, arg){ // 删除订单详情商品
            return new Promise((resolve) => {
                let url = "/index/orderstatus/goods_delete",
                data = qs.stringify({
                    rec_id: arg
                })
                axios({
                    method: "POST",
                    url,
                    data
                }).then((res) => {
                    if(res.data.code == 1){
                        resolve(true)
                    }
                }).catch(() => {})
            })
        },
        handleReturn({ commit, dispatch }, arg){ // 退换货申请
            return new Promise((resolve) => {
                let { order_id, pay_note } = arg,
                url = "/index/orderstatus/return_goods",
                data = qs.stringify({
                    order_id,
                    pay_note
                })
                axios({
                    method: "POST",
                    url,
                    data
                }).then((res) => {
                    if(res.data.code == 1){
                        setTimeout(() => {
                            dispatch("getOrderStatusList", {
                                release,
                                relend,
                                order_sn,
                                department,
                                user_id
                            }); // 刷新列表
                        },100);
                        commit("handleDialog", false); // 关闭模态框
                        resolve(true);
                    }
                }).catch(() => {})
            })
        },
        handleOrderCancel({ commit, dispatch }, arg) { // 订单取消申请
            return new Promise((resolve, reject) => {
                let { order_id, cancel_note } = arg,
                url = "/index/orderstatus/return_cancel",
                data = qs.stringify({
                    order_id,
                    cancel_note
                })
                axios({
                    method: "POST",
                    url,
                    data
                }).then((res) => {
                    commit("handleDialog", false); // 关闭模态框
                    resolve({
                        type: res.data.code == 1
                    });
                    if(res.data.code == 1){
                        setTimeout(() => {
                            dispatch("getOrderStatusList", {
                                release,
                                relend,
                                order_sn,
                                department,
                                user_id
                            }); // 刷新列表
                        },100);
                    }
                }).catch(() => {})
            })
        },
        handleAuditor({ state, commit, dispatch }, arg){ // 审核员 审批状态 / 是否允许修改
            return new Promise((resolve) => {
                let { order_id, status, remark } = arg,
                url_status = "/index/orderstatus/implement",
                url_modify = "/index/orderstatus/allow",
                url = null,
                data = qs.stringify({
                    order_id,
                    status,
                    remark
                })
                if(state.examine == 1){
                    url = url_status;
                }else{
                    url = url_modify;
                }
                axios({
                    method: "POST",
                    url,
                    data
                }).then((res) => {
                    if(res.data.code == 1){
                        setTimeout(() => {
                            dispatch("getOrderStatusList", {
                                release,
                                relend,
                                order_sn,
                                department,
                                user_id
                            });
                        },100); // 刷新列表
                        commit("handleDialog", false); // 关闭模态框
                        resolve(true);
                    }
                }).catch(() => {})
            })
        },
        handleLower({ state, commit, dispatch }, arg){ // 下单员提交
            return new Promise((resolve) => {
                let { order_id, remark } = arg,
                url_complete = "/index/orderstatus/complete",
                url_apply = "/index/orderstatus/apply",
                url = null,
                data = qs.stringify({
                    order_id,
                    remark
                })
                if(state.examine == 2){
                    url = url_complete;
                }else{
                    url = url_apply;
                }
                axios({
                    method: "POST",
                    url,
                    data
                }).then((res) => {
                    if(res.data.code == 1){
                        setTimeout(() => {
                            dispatch("getOrderStatusList", {
                                release,
                                relend,
                                order_sn,
                                department,
                                user_id
                            });
                        },100); // 刷新列表
                        commit("handleDialog", false); // 关闭模态框
                        resolve(true);
                    }
                }).catch(() => {})
            })
        },
        handleDelOrder({ state, commit }){ // 删除订单
            commit("handleLoading", true);
            let order_id = state.order_detail.order_id,
            url = "/index/orderstatus/delete_order",
            data = qs.stringify({
                order_id
            })
            return new Promise((resolve) => {
                axios({
                    method: "POST",
                    url,
                    data
                }).then((res) => {
                    commit("handleLoading", false);
                    if(res.data.code == 1){
                        commit("handleDialog", false);
                        resolve({
                            type: true
                        })
                    }
                }).catch(err => {
                    commit("handleLoading", false);
                    alert(`删除订单接口异常：${err}，请联系管理员`);
                })
            })
        },
        handleOrderStatusExcel({ state, commit }, arg){ // 下载订单状态excel
            commit("handleLoading", true);
            let { release = "", relend = "", order_sn = "", department = "", user_id = "" } = arg,
            status = "",orstatus = "";
            switch(state.order_tabs){
                case "0":
                    status = 0;
                    break;
                case "1":
                    status = 1;
                    break;
                case "2":
                    status = 3;
                    break;
                case "3":
                    status = 2;
                    break;
                case "4":
                    orstatus = 3;
                    break;
                case "5":
                    orstatus = 2;
                    break;
                case "6":
                    orstatus = 1;
                    break;
                case "7":
                    orstatus = 7;
                    break;
            }
            let url = "/index/orderstatus/order_excel",
            param = qs.stringify({
                lang,
                release,
                relend,
                order_sn,
                department,
                user_id,
                status,
                orstatus
            })
            return new Promise((resolve) => {
                axios.post(url, param, {
                    responseType: 'blob'
                }).then((res) => {
                    commit("handleLoading", false);
                    resolve(res.data)
                }).catch(err => {
                    commit("handleLoading", false);
                    alert(`下载订单状态excel接口异常：${err}，请联系管理员`);
                })
            })
        },
        // 
        // ************* 支付状态 ********************
        //
        getPayStatusList({ state, commit }, arg){ // 获取支付状态列表
            commit('clearOrderStatusList');
            commit('handleLoading', true);
            let { release = '', relend = '', order_sn = '', department = '', user_id = '', attr: sortAttr = '', mode: sortMode = '', page } = arg,
            pay_status = state.order_tabs==9?'':state.order_tabs,
            url = '/index/paystatus/pay_status',
            data = qs.stringify({
                lang,
                release,
                relend,
                order_sn,
                department,
                user_id,
                pay_status,
                sortAttr,
                sortMode,
                page
            })
            axios({
                method: 'POST',
                url,
                data
            }).then((res) => {
                if(res.data.code == 1){
                    commit('setOrderStatusList', res.data.order);
                    commit('setPage', res.data.page);
                }
            }).catch(err => {
                alert(`获取支付状态列表接口异常：${err}，请联系管理员`);
            }).finally(() => {commit('handleLoading', false)})
        },
        getPayStatusDetail({ commit }, arg){ // 获取支付状态详情
            commit("clearOrderStatusDetail");
            commit("handleLoading", true);
            let url = "/index/paystatus/goods",
            data = qs.stringify({
                id: arg
            })
            axios({
                method: "POST",
                url,
                data
            }).then((res) => {
                commit("handleLoading", false);
                if(res.data.code == 1){
                    commit("setOrderStatusDetail", res.data);
					commit("removeUnnecessaryParameters2", res.data);
                    commit("handleDialog", true);
                }
            }).catch(err => {
                commit("handleLoading", false);
                alert(`获取支付状态详情接口异常：${err}，请联系管理员`);
            })
        },
        handlePayStatusExcel({ state, commit }, arg){ // 下载订单状态excel
            commit("handleLoading", true);
            let { release = "", relend = "", order_sn = "", department = "", user_id = "" } = arg,
            pay_status = state.order_tabs==9?"":state.order_tabs,
            url = "/index/orderstatus/order_excel",
            param = qs.stringify({
                lang,
                release,
                relend,
                order_sn,
                department,
                user_id,
                pay_status
            })
            return new Promise((resolve) => {
                axios.post(url, param, {
                    responseType: 'blob'
                }).then((res) => {
                    commit("handleLoading", false);
                    resolve(res.data)
                }).catch(err => {
                    commit("handleLoading", false);
                    alert(`下载订单状态excel接口异常：${err}，请联系管理员`);
                })
            })
        },
        // 
        // ************* 订单管理 ********************
        // 
        getOrderList({ state, commit }, arg){ // 获取订单列表
            commit("setOrderList", []);
            commit("handleLoading", true);
            let { release = "", relend = "", order_sn = "", department = "", user_id = "" } = arg,
            order_status = "";
            if(state.order_tabs != "9"){
                order_status = state.order_tabs;
            }
            let url = "/index/order/order",
            data = qs.stringify({
                lang,
                release,
                relend,
                order_sn,
                department,
                user_id,
                order_status
            })
            axios({
                method: "POST",
                url,
                data
            }).then((res) => {
                if(res.data.code == 1){
                    commit("setOrderList", res.data.order);
                    commit("handleLoading", false);
                }
            }).catch(err => {
                commit("handleLoading", false);
                alert(`获取订单列表接口异常：${err}，请联系管理员`);
            })
        },
        getOrderMonth({ state, commit }, arg){ // 获取当月订单列表
            commit("handleLoading", true);
            let { month, order_sn, department, user_id, release, relend ,page} = arg,
            order_status = "";
            if(state.order_tabs != "9"){
                order_status = state.order_tabs;
            }
            let url = "/index/order/month_list",
            data = qs.stringify({
                lang,
                month,
                release,
                relend,
                order_sn,
                department,
                user_id,
                order_status,
				page
            })
            axios({
                method: "POST",
                url,
                data
            }).then((res) => {
                if(res.data.code == 1){
                    commit("setOrderMonth", res.data.order);
					commit("setMonth", month);
					commit("setOrderMonthPage", res.data.page);
                    commit("handleLoading", false);
                    commit("handleDialog", true);
                }
            }).catch(err => {
                commit("handleLoading", false);
                alert(`获取当月订单列表接口异常：${err}，请联系管理员`);
            })
        },
        handleOrderExcel({ state, commit }, arg){ // 下载订单汇总excel
            commit("handleLoading", true);
            let { release = "", relend = "", order_sn = "", department = "", user_id = "" } = arg,
            status = "",orstatus = "";
            switch(state.order_tabs){
                case "0":
                    status = 0;
                    break;
                case "1":
                    status = 1;
                    break;
                case "2":
                    status = 3;
                    break;
                case "3":
                    status = 2;
                    break;
                case "4":
                    orstatus = 3;
                    break;
                case "5":
                    orstatus = 2;
                    break;
                case "6":
                    orstatus = 1;
                    break;
                case "7":
                    orstatus = 7;
                    break;
            }
            let url = "/index/order/order_excel",
            param = qs.stringify({
                lang,
                release,
                relend,
                order_sn,
                department,
                user_id,
                status,
                orstatus
            })
            return new Promise((resolve) => {
                axios.post(url, param, {
                    responseType: 'blob'
                }).then((res) => {
                    commit("handleLoading", false);
                    resolve(res.data)
                }).catch(err => {
                    commit("handleLoading", false);
                    alert(`下载订单汇总excel接口异常：${err}，请联系管理员`);
                })
            })
        },
        // 
        // ************* 报价车 ********************
        // 
        getQuoteCart({commit, rootState}){ // 获取报价车
            if(rootState.user.islogin){
                let url = "/index/quote/quote_list?lang=" + lang;
                axios.get(url).then((res) => {
                    if(res.data.code == 1){
                        commit("setQuoteCart", res.data.quote)
                    }
                }).catch(() => {})
            }
        },
        handleQuoteCartNum({dispatch}, arg){ // 报价车数量更改
            let { goods_number, quo_id, goods_attr_id, goods_specification_id } = arg;
            let url = "/index/quote/change", 
            data = qs.stringify({
                quo_id,
                goods_number,
                goods_attr_id,
                goods_specification_id
            })
            axios({
                method: "POST",
                url,
                data
            }).then((res) => {
                if(res.data.code == 1){
                    dispatch("getQuoteCart");
                }
            }).catch(() => {})
        },
        handleQuoteCartDel({dispatch}, arg){ //报价车删除
            return new Promise((resolve) => {
                let url = "/index/quote/delete",
                data = qs.stringify({
                    quo_id: arg
                })
                axios({
                    method: "POST",
                    url,
                    data
                }).then((res) => {
                    if(res.data.code == 1){
                        dispatch("getQuoteCart");
                        resolve(true)
                    }
                }).catch(() => {})
            })
        },
        handleSubmitQuoteCart({ dispatch, commit }, {goods, postscript}){ // 提交报价车
            commit("handleLoading", true);
            let url = "/index/quote/add",
            data = qs.stringify({
                goods,
                postscript
            })
            return new Promise((resolve) => {
                axios({
                    method: "POST",
                    url,
                    data
                }).then((res) => {
                    commit("handleLoading", false);
                    if(res.data.code == 1){
                        dispatch("getQuoteCart");
                        resolve(true)
                    }else if(res.data.code == 2){
						resolve(false)
					}
                }).catch(err => {
                    commit("handleLoading", false);
                    alert(`提交报价车接口异常：${err}，请联系管理员`);
                })
            })
        },
        handleQuoteCartToCart({ dispatch, commit }, arg){ // 报价车添加购物车
            commit("handleLoading", true);
            let url = "/index/quoteorder/cart",
            data = qs.stringify({
                lang,
                goods: arg
            })
            return new Promise((resolve) => {
                axios({
                    method: "POST",
                    url,
                    data
                }).then((res) => {
                    commit("handleLoading", false);
                    if(res.data.code == 1){
                        dispatch("getCart");
                        resolve(true)
                    }else if (res.data.code == 5){
                        dispatch("getCart");
                        resolve(false)
                    }
                }).catch(err => {
                    commit("handleLoading", false);
                    alert(`报价车添加购物车接口异常：${err}，请联系管理员`);
                })
            })
        },
        // 
        // ************* 报价车订单 ********************
        // 
        getQuoteOrderList({ rootState, commit }, arg){ // 获取报价车订单
            commit("handleLoading", true);
            if(rootState.user.islogin){
                let  { 
                    release = "", 
                    relend = "", 
                    complete_status="",
                    attr: sortAttr = '',
                    mode: sortMode = '',
                    page = 1
                } = arg,
                url = "/index/quoteorder/quote_list",
                data = qs.stringify({
                    lang,
                    release,
                    relend,
                    complete_status,
                    sortAttr,
                    sortMode,
                    page
                })
                axios({
                    method: "POST",
                    url,
                    data
                }).then((res) => {
                    if(res.data.code == 1){
                        commit("setQuoteOrderList", res.data.quote);
                        commit('setPage', res.data.page);
                    }
                }).catch(err => {
                    alert(`获取报价车订单接口异常：${err}，请联系管理员`);
                }).finally(() => {commit("handleLoading", false)})
            }
        },
        getQuoteOrderDetail({commit}, arg){ // 获取报价车订单详情
            commit("setQuoteOrderDetail", {});
            commit("handleLoading", true);
            let url = "/index/quoteorder/goods",
            data = qs.stringify({
                quote_id: arg
            })
            axios({
                method: "POST",
                url,
                data
            }).then((res) => {
                if(res.data.code == 1){
                    commit("setQuoteOrderDetail", res.data);
					commit("removeUnnecessaryParameters", res.data);
                    commit("handleLoading", false);
                    commit("handleDialog", true);
                }
            }).catch(err => {
                commit("handleLoading", false);
                alert(`获取报价车订单详情接口异常：${err}，请联系管理员`);
            })
        },
	
        handleQuoteOrderImplement({commit}, arg) { // 报价车审核
            commit("handleLoading", true);
            let {
                quote_id = "",
                status = "",
                remark = ""
            } = arg,
            url = "/index/quoteorder/implement",
            data = qs.stringify({
                quote_id,
                status,
                remark
            })
            return new Promise((resolve, reject) => {
                axios({
                    method: "POST",
                    url,
                    data
                }).then(res => {
                    commit("handleLoading", false);
                    console.log(res)
                    resolve({
                        type: res.data.code == 1
                    })
                }).catch(err => {
                    commit("handleLoading", false);
                    alert(`报价车审核接口异常：${err}，请联系管理员`);
                })
            })
        },
		addOrderShoppingCart({ dispatch, commit, state}, arg){ // 訂單订单加入购物车
		    commit("handleLoading", true);
		    let url = "/index/orderstatus/cart",
		    data = qs.stringify({
		        lang,
		        goods: arg,
				order_sn:state.order_goodsr_quote_sn
		    })
		    return new Promise((resolve) => {
		        axios({
		            method: "POST",
		            url,
		            data
		        }).then((res) => {
		            commit("handleLoading", false);
		            dispatch("getCart");
					commit("handleDialog", false); // 关闭模态框
		            if(res.data.code == 1){
		                resolve({
		                    type: true,
		                    msg: ""
		                });
						
		            }else if(res.data.code == 5){
		                resolve({
		                    type: false,
		                    msg: res.data.msg,
		                });
		            }
		        }).catch(err => {
		            commit("handleLoading", false);
		            alert(`订单加入购物车接口异常：${err}，请联系管理员`);
		        })
		    })
		},
        handleQuoteOrderAdd({ dispatch, commit, state}, arg){ // 报价车订单加入购物车
            commit("handleLoading", true);		
            let url = "/index/quoteorder/cart",
            data = qs.stringify({
                lang,
                goods: arg,
				quote_sn:state.quote_order_quote_sn
            })
            return new Promise((resolve) => {
                axios({
                    method: "POST",
                    url,
                    data
                }).then((res) => {
                    commit("handleLoading", false);
                    dispatch("getCart");
                    if(res.data.code == 1){
                        resolve({
                            type: true,
                            msg: ""
                        });
                    }else if(res.data.code == 5){
                        resolve({
                            type: false,
                            msg: res.data.msg,
                        });
                    }
                }).catch(err => {
                    commit("handleLoading", false);
                    alert(`报价车订单加入购物车接口异常：${err}，请联系管理员`);
                })
            })
        },

        handleAddCart({dispatch}, arg){ // 加入购物车或报价车
            let { user_id, goods_id, goods_number, goods_attr_id, goods_specification_id, url } = arg,
            data = qs.stringify({
                user_id,
                goods_id,
                goods_number,
                goods_attr_id,
                goods_specification_id
            })
            return new Promise((resolve) => {
               axios({
                    method: "POST",
                    url,
                    data
                }).then((res) => {
                    if(res.data.code == 1){
                        dispatch("getCart")
                        dispatch("getQuoteCart")
                        resolve({
                            type: 1,
                            msg: res.data.msg || ""
                        })
                    }else if(res.data.code == 2){
                        resolve({
                            type: 2,
                            msg: res.data.msg
                        })
                    }else if(res.data.code == 5){
                        resolve({
                            type: 5,
                            msg: res.data.msg
                        })
                    }
                }).catch(() => {}) 
            })
        }
    },
}